exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.p-sresult[data-v-5664b8b6] {\n  height: 100%;\n}\n.p-sresult .search[data-v-5664b8b6] {\n  padding: 0.266667rem /* 20/75 */;\n  background: #f0f0f0;\n}\n.p-sresult .result[data-v-5664b8b6] {\n  position: absolute;\n  top: 1.653333rem /* 124/75 */;\n  bottom: 0;\n  width: 100%;\n  background: #fff;\n  overflow: hidden;\n}\n.p-sresult .result .result__container .card__outer .c-card:last-child .card__border[data-v-5664b8b6] {\n  display: none;\n}\n", ""]);

// exports
